package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.List
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Checkbox
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.colaboradores.DatasColab
import br.com.htms.inspeccaocampo.data.EvidenciaTreinamento
import br.com.htms.inspeccaocampo.data.EvidenciaTreinamentoApi
import br.com.htms.inspeccaocampo.data.PessoaEvidencia
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.platform.PlatformServices
import br.com.htms.inspeccaocampo.shared.ui.components.AppDateTextField
import br.com.htms.inspeccaocampo.ui.kit.Campo
import br.com.htms.inspeccaocampo.ui.kit.CampoBusca
import br.com.htms.inspeccaocampo.ui.kit.CartaoSecao
import br.com.htms.inspeccaocampo.ui.kit.Celula
import br.com.htms.inspeccaocampo.ui.kit.CelulaCabecalho
import br.com.htms.inspeccaocampo.ui.kit.LinhaTabela
import br.com.htms.inspeccaocampo.ui.kit.Par
import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import br.com.htms.inspeccaocampo.ui.kit.PortalMenuItem
import br.com.htms.inspeccaocampo.ui.kit.PortalModal
import br.com.htms.inspeccaocampo.ui.kit.PortalModulo
import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton
import br.com.htms.inspeccaocampo.ui.kit.Seletor
import br.com.htms.inspeccaocampo.ui.kit.TabelaPortal
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import kotlinx.coroutines.launch

@Composable
fun SharedEvidenciaTreinamentoScreen(controller: AppController) {
    val obras by controller.obrasAtivas.collectAsState()
    val auth by controller.authUser.collectAsState()
    var aba by remember { mutableStateOf("novo") }
    var tsts by remember { mutableStateOf(emptyList<PessoaEvidencia>()) }
    var funcionarios by remember { mutableStateOf(emptyList<PessoaEvidencia>()) }
    var lancados by remember { mutableStateOf(emptyList<EvidenciaTreinamento>()) }
    var obra by remember { mutableStateOf("") }
    var tst by remember { mutableStateOf("") }
    var curso by remember { mutableStateOf("") }
    var data by remember { mutableStateOf("") }
    var carga by remember { mutableStateOf("") }
    var presentes by remember { mutableStateOf(setOf<String>()) }
    var deFora by remember { mutableStateOf(setOf<String>()) }
    var busca by remember { mutableStateOf("") }
    var buscaFora by remember { mutableStateOf("") }
    var mostrarFora by remember { mutableStateOf(false) }
    var fotos by remember { mutableStateOf(listOf<Pair<String, ByteArray>>()) }
    var erro by remember { mutableStateOf<String?>(null) }
    var aviso by remember { mutableStateOf<String?>(null) }
    var salvando by remember { mutableStateOf(false) }
    val scope = rememberCoroutineScope()

    suspend fun recarregar() {
        EvidenciaTreinamentoApi.apoio().onSuccess { apoio ->
            tsts = apoio.tsts
            funcionarios = apoio.funcionarios
            if (tst.isBlank()) tst = tsts.firstOrNull { it.id.equals(auth?.username, true) }?.id.orEmpty()
        }
        EvidenciaTreinamentoApi.listar().onSuccess { lancados = it }
    }

    LaunchedEffect(Unit) { recarregar() }

    val horas = carga.replace(',', '.').toDoubleOrNull() ?: 0.0
    val homemHora = if (horas > 0 && presentes.isNotEmpty()) horas * presentes.size else 0.0
    val opObras = obras.map { it.nome }.filter { it.isNotBlank() }.distinct().map { it to it }
    val opTst = tsts.map { it.id to it.nome }
    val daObra = funcionarios.filter { pertenceObra(it, obra) }
    val filtrados = daObra.filter { casaBusca(it, busca) }
    val incluidosFora = funcionarios.filter { it.id in deFora }
    val outros = funcionarios.filter { !pertenceObra(it, obra) && it.id !in deFora && casaBusca(it, buscaFora) }.take(80)

    fun limpar() {
        curso = ""
        data = ""
        carga = ""
        presentes = emptySet()
        deFora = emptySet()
        fotos = emptyList()
        busca = ""
        buscaFora = ""
        mostrarFora = false
    }

    fun escolherObra(nova: String) {
        obra = nova
        val ids = funcionarios.filter { pertenceObra(it, nova) }.map { it.id }.toSet()
        presentes = presentes.filter { it in ids || it in deFora }.toSet()
    }

    PortalModulo(
        titulo = "Evidência de Treinamento",
        itens = listOf(
            PortalMenuItem("novo", "Novo registro", Icons.Filled.Edit),
            PortalMenuItem("lista", "Lançados", Icons.Filled.List)
        ),
        selecionado = aba,
        onSelect = { aba = it }
    ) { largo ->
        if (aba == "lista") {
            CartaoSecao("Registros", subtitulo = "${lancados.size} evidência(s)") {
                if (lancados.isEmpty()) {
                    Text("Nenhum treinamento lançado.", color = PortalCores.CinzaTexto)
                } else {
                    TabelaPortal(cabecalho = {
                        CelulaCabecalho("Curso", 1.6f)
                        CelulaCabecalho("Obra", 1.4f)
                        if (largo) CelulaCabecalho("TST", 1.2f)
                        CelulaCabecalho("Data", 0.8f)
                        CelulaCabecalho("Homem-hora", 0.8f)
                        CelulaCabecalho("Fotos", 0.5f)
                    }) {
                        lancados.forEach { e ->
                            LinhaTabela {
                                Celula(e.curso, 1.6f, negrito = true)
                                Celula(e.obra, 1.4f)
                                if (largo) Celula(e.tstNome, 1.2f)
                                Celula(DatasColab.isoParaBr(e.realizadoEm), 0.8f)
                                Celula(fmtHora(e.homemHora), 0.8f)
                                Celula(e.fotos.toString(), 0.5f)
                            }
                        }
                    }
                }
            }
        } else {
            CartaoSecao(
                "Dados do curso",
                subtitulo = "A homem-hora (carga × presentes) soma no Homem-hora de treinamento do REM HTMS, no mês da data."
            ) {
                Par(
                    largo,
                    { m -> Seletor("Obra / centro de custo", opObras, obra, { escolherObra(it) }, m) },
                    { m -> Seletor("TST ministrando", opTst, tst, { tst = it }, m) }
                )
                Par(
                    largo,
                    { m -> Campo("Curso", curso, modifier = m) { curso = it } },
                    { m -> AppDateTextField(value = data, onValueChange = { data = it }, label = "Realizado em", modifier = m) }
                )
                Campo("Carga horária do curso", carga, numero = true) { carga = it.filter { c -> c.isDigit() || c == ',' || c == '.' }.take(5) }
                Text(
                    if (homemHora > 0) "Entra no REM deste mês: ${homemHora.toString().trimEnd('0').trimEnd('.')} homem-hora"
                    else "Informe a carga e marque a lista de presença para calcular a homem-hora.",
                    color = PortalCores.CinzaTexto,
                    style = MaterialTheme.typography.bodySmall
                )
            }
            CartaoSecao("Fotos", subtitulo = "${fotos.size} de 12") {
                Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    PortalOutlinedButton(onClick = {
                        scope.launch {
                            PlatformServices.notifyPhotoPickerOpening()
                            val foto = PlatformServices.capturePhoto() ?: return@launch
                            val bytes = PlatformServices.loadImageBytes(foto.path) ?: return@launch
                            if (fotos.size < 12) fotos = fotos + ("foto-${fotos.size + 1}.jpg" to bytes)
                        }
                    }) { Text("Tirar foto") }
                    PortalOutlinedButton(onClick = {
                        scope.launch {
                            PlatformServices.notifyPhotoPickerOpening()
                            val foto = PlatformServices.pickImage() ?: return@launch
                            val bytes = PlatformServices.loadImageBytes(foto.path) ?: return@launch
                            if (fotos.size < 12) fotos = fotos + (nomeArquivo(foto.path) to bytes)
                        }
                    }) { Text("Escolher imagem") }
                }
                fotos.forEachIndexed { i, (nome, _) ->
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Text(nome, Modifier.weight(1f), color = PortalCores.Texto)
                        PortalOutlinedButton(onClick = { fotos = fotos.filterIndexed { idx, _ -> idx != i } }) { Text("Remover") }
                    }
                }
            }
            CartaoSecao(
                "Lista de presença",
                subtitulo = if (obra.isBlank()) "Escolha a obra para ver quem está nesse centro de custo."
                else "${presentes.size} marcado(s) · ${daObra.size} neste centro"
            ) {
                if (obra.isBlank()) {
                    Text("A lista mostra só os colaboradores do centro de custo da obra.", color = PortalCores.CinzaTexto)
                } else {
                    CampoBusca(busca, { busca = it }, "Buscar por nome ou matrícula", Modifier.fillMaxWidth())
                    if (filtrados.isEmpty()) {
                        Text("Nenhum colaborador deste centro com esse filtro.", color = PortalCores.CinzaTexto)
                    } else {
                        TabelaPresenca(filtrados, largo, presentes) { id, marcado ->
                            presentes = if (marcado) presentes + id else presentes - id
                        }
                    }
                    if (incluidosFora.isNotEmpty()) {
                        Text("De outra obra", color = PortalCores.Texto, fontWeight = FontWeight.SemiBold)
                        TabelaPresenca(incluidosFora, largo, presentes, mostrarCentro = true) { id, marcado ->
                            if (marcado) presentes = presentes + id
                            else {
                                presentes = presentes - id
                                deFora = deFora - id
                            }
                        }
                    }
                    PortalOutlinedButton(onClick = { buscaFora = ""; mostrarFora = true }) {
                        Text("Adicionar de outra obra")
                    }
                }
            }
            if (mostrarFora) {
                PortalModal(onFechar = { mostrarFora = false }, larguraMax = 720.dp) {
                    Column(Modifier.padding(20.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {
                        Text("Adicionar de outra obra", color = PortalCores.Navy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleLarge)
                        Text("Quem não está no centro ${obra.ifBlank { "selecionado" }}.", color = PortalCores.CinzaTexto)
                        CampoBusca(buscaFora, { buscaFora = it }, "Buscar por nome ou matrícula", Modifier.fillMaxWidth())
                        if (outros.isEmpty()) {
                            Text("Nenhum colaborador encontrado.", color = PortalCores.CinzaTexto)
                        } else {
                            TabelaPresenca(outros, true, presentes, mostrarCentro = true) { id, marcado ->
                                if (marcado) {
                                    deFora = deFora + id
                                    presentes = presentes + id
                                } else {
                                    deFora = deFora - id
                                    presentes = presentes - id
                                }
                            }
                        }
                        PortalButton(onClick = { mostrarFora = false }) { Text("Concluir") }
                    }
                }
            }
            erro?.let { Text(it, color = PortalCores.Vermelho, fontWeight = FontWeight.SemiBold) }
            aviso?.let { Text(it, color = PortalCores.Verde, fontWeight = FontWeight.SemiBold) }
            PortalButton(enabled = !salvando, onClick = {
                val iso = DatasColab.entradaParaIso(data)
                when {
                    obra.isBlank() -> erro = "Informe a obra."
                    tst.isBlank() -> erro = "Escolha o TST."
                    curso.trim().length < 2 -> erro = "Informe o curso."
                    iso.isBlank() -> erro = "Informe a data do curso."
                    horas <= 0.0 || horas > 24.0 -> erro = "A carga horária deve ser maior que zero e de no máximo 24 horas."
                    presentes.isEmpty() -> erro = "Marque ao menos um funcionário na lista de presença."
                    else -> {
                        erro = null
                        aviso = null
                        salvando = true
                        scope.launch {
                            val salvo = EvidenciaTreinamentoApi.criar(obra, tst, curso.trim(), iso, horas, presentes)
                            val (id, total) = salvo.getOrElse {
                                erro = it.message ?: "Não foi possível salvar."
                                salvando = false
                                return@launch
                            }
                            var falhas = 0
                            fotos.forEach { (_, bytes) ->
                                EvidenciaTreinamentoApi.foto(id, bytes).onFailure { falhas++ }
                            }
                            val emailOk = EvidenciaTreinamentoApi.avisar(id).getOrDefault(false)
                            aviso = buildString {
                                append("Registrado. Homem-hora de treinamento do REM neste mês: ${fmtHora(total)}.")
                                if (falhas > 0) append(" $falhas foto(s) não subiram.")
                                append(
                                    if (emailOk) " E-mail enviado para admqsms@htmsgroup.com."
                                    else " O e-mail não foi enviado."
                                )
                            }
                            limpar()
                            recarregar()
                            salvando = false
                        }
                    }
                }
            }) { Text(if (salvando) "Salvando..." else "Salvar") }
        }
    }
}

@Composable
private fun TabelaPresenca(
    pessoas: List<PessoaEvidencia>,
    largo: Boolean,
    presentes: Set<String>,
    mostrarCentro: Boolean = false,
    onMarcar: (String, Boolean) -> Unit
) {
    TabelaPortal(cabecalho = {
        CelulaCabecalho("", 0.45f)
        CelulaCabecalho("Colaborador", 2.2f)
        CelulaCabecalho("Matrícula", 0.8f)
        if (largo) CelulaCabecalho("Função", 1.4f)
        if (mostrarCentro) CelulaCabecalho("Centro", 1.4f)
    }) {
        pessoas.forEach { f ->
            LinhaTabela {
                Box(Modifier.weight(0.45f), contentAlignment = Alignment.CenterStart) {
                    Checkbox(checked = f.id in presentes, onCheckedChange = { onMarcar(f.id, it) })
                }
                Celula(f.nome, 2.2f, negrito = true)
                Celula(f.matricula.ifBlank { "—" }, 0.8f)
                if (largo) Celula(f.cargo.ifBlank { "—" }, 1.4f)
                if (mostrarCentro) Celula(f.ccRotulo.ifBlank { "Sem centro" }, 1.4f)
            }
        }
    }
}

private fun pertenceObra(f: PessoaEvidencia, obra: String): Boolean {
    if (obra.isBlank()) return false
    if (f.ccRotulo.equals(obra, true)) return true
    val codigo = obra.substringBefore(" - ").trim()
    return codigo.isNotBlank() && codigo.equals(f.ccCodigo, true)
}

private fun casaBusca(f: PessoaEvidencia, busca: String): Boolean =
    busca.isBlank() || f.nome.contains(busca, true) || f.matricula.contains(busca, true) || f.cargo.contains(busca, true)

private fun nomeArquivo(path: String): String =
    path.substringAfterLast('/').substringAfterLast('\\').ifBlank { "foto.jpg" }

private fun fmtHora(n: Double): String =
    if (n % 1.0 == 0.0) n.toInt().toString() else n.toString()
